import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'

export const handleCloudPlanReady = (async (params: {
  previousToolCallFinished: Promise<unknown>
  toolCall: AnvilToolCall<'cloud_plan_ready'>
}): Promise<{ output: AnvilToolOutput<'cloud_plan_ready'> }> => {
  await params.previousToolCallFinished
  return {
    output: [
      {
        type: 'json',
        value: { message: 'The project plan is ready for approval.' },
      },
    ],
  }
}) satisfies AnvilToolHandlerFunction<'cloud_plan_ready'>
